<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">KEUANGAN</span>
                <span v-else>FINANCE</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Keuangan</span>
                    <span v-else>Finance</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        REKAPITULASI REALISASI KEGIATAN
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        RECAPITULATION OF REALIZATION OF ACTIVITIES
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Tanggal Integrasi Data (PMIS, LMS & E-mon): {{ G_formatDate(tanggalsinkron) }}
                    <br>Tanggal Data Monev PMC: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                </p>
                <p class="mb-0" v-else>
                    Data Integration Date (PMIS, LMS & E-mon): {{ G_formatDateEng(tanggalsinkron) }}
                    <br>PMC Monev Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="row">
                    <div class="col-sm-12 wow fadeInDown">
                        <div class="card cardputih collapsed-card">
                            <div class="card-header border-transparent" data-card-widget="collapse"
                                style="cursor: pointer;">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                                    <span v-else>Column Filter</span>
                                </label>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body px-3">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOWPPMIS" value="optionOWPPMIS"
                                                @click="showColumnOWPPMIS = !showColumnOWPPMIS" checked>
                                            <label for="customCheckboxOWPPMIS" class="custom-control-label">
                                                OWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOWPMONEV" value="optionOWPMONEV"
                                                @click="showColumnOWPMONEV = !showColumnOWPMONEV">
                                            <label for="customCheckboxOWPMONEV" class="custom-control-label">
                                                OWP Monev</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxAWPPMIS" value="optionAWPPMIS"
                                                @click="showColumnAWPPMIS = !showColumnAWPPMIS" checked>
                                            <label for="customCheckboxAWPPMIS" class="custom-control-label">
                                                AWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxAWPMONEV" value="optionAWPMONEV"
                                                @click="showColumnAWPMONEV = !showColumnAWPMONEV">
                                            <label for="customCheckboxAWPMONEV" class="custom-control-label">
                                                AWP Monev</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxDIPAPMIS" value="optionDIPAPMIS"
                                                @click="showColumnDIPAPMIS = !showColumnDIPAPMIS" checked>
                                            <label for="customCheckboxDIPAPMIS" class="custom-control-label">
                                                DIPA</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxDIPAMONEV" value="optionDIPAMONEV"
                                                @click="showColumnDIPAMONEV = !showColumnDIPAMONEV">
                                            <label for="customCheckboxDIPAMONEV" class="custom-control-label">
                                                DIPA Monev</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxSPMPMIS" value="optionSPMPMIS"
                                                @click="showColumnSPMPMIS = !showColumnSPMPMIS" checked>
                                            <label for="customCheckboxSPMPMIS" class="custom-control-label">
                                                SPM</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldata" style="font-size: smaller !important;">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" rowspan="2">No</th>
                                    <th style="width: 150px;" rowspan="2">PIU</th>
                                    <th style="width: 150px;" rowspan="2" v-if="showColumnOWPPMIS">OWP (Rp. / IDR)</th>
                                    <th style="width: 150px;" rowspan="2" v-if="showColumnOWPMONEV">OWP<br>MONEV (Rp. /
                                        IDR)</th>
                                    <th style="width: 100px;" :colspan="datatahun.length" v-if="showColumnAWPPMIS">AWP</th>
                                    <th style="width: 100px;" :colspan="datatahun.length" v-if="showColumnAWPMONEV">AWP Monev</th>
                                    <th style="width: 100px;" :colspan="datatahun.length" v-if="showColumnDIPAPMIS">DIPA</th>
                                    <th style="width: 100px;" :colspan="datatahun.length" v-if="showColumnDIPAMONEV">DIPA Monev</th>
                                    <th style="width: 100px;" :colspan="datatahun.length" v-if="showColumnSPMPMIS">SPM</th>
                                </tr>
                                <tr>
                                    <th v-if="showColumnAWPPMIS" v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        {{ listtahun.tahun }}
                                    </th>
                                    <th  v-if="showColumnAWPMONEV" v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        {{ listtahun.tahun }}
                                    </th>
                                    <th v-if="showColumnDIPAPMIS" v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        {{ listtahun.tahun }}
                                    </th>
                                    <th  v-if="showColumnDIPAMONEV" v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        {{ listtahun.tahun }}
                                    </th>
                                    <th v-if="showColumnSPMPMIS" v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        {{ listtahun.tahun }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                    <tr>
                                        <td class="total" colspan="2"> TOTAL</td>
                                        <td class="totalkanan" v-if="showColumnOWPPMIS">{{
                                            G_numFormat(datalist.OWPTOTAL) }}</td>
                                        <td class="totalkanan" v-if="showColumnOWPMONEV">{{
                                            G_numFormat(datalist.OWPTOTALMONEV) }}</td>
                                        <td v-if="showColumnAWPPMIS" class="totalkanan" v-for="(listtahun, uruttahun) in datatahun"
                                            :key="uruttahun">
                                            {{ G_numFormat(listtahun.awp) }}
                                        </td>
                                        <td v-if="showColumnAWPMONEV" class="totalkanan" v-for="(listtahun, uruttahun) in datatahun"
                                            :key="uruttahun">
                                            {{ G_numFormat(listtahun.awpmonev) }}
                                        </td>
                                        <td v-if="showColumnDIPAPMIS" class="totalkanan" v-for="(listtahun, uruttahun) in datatahun"
                                            :key="uruttahun">
                                            {{ G_numFormat(listtahun.dipa) }}
                                        </td>
                                        <td v-if="showColumnDIPAMONEV" class="totalkanan" v-for="(listtahun, uruttahun) in datatahun"
                                            :key="uruttahun">
                                            {{ G_numFormat(listtahun.dipamonev) }}
                                        </td>
                                        <td v-if="showColumnSPMPMIS" class="totalkanan" v-for="(listtahun, uruttahun) in datatahun"
                                            :key="uruttahun">
                                            {{ G_numFormat(listtahun.spmtahun) }}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                            <template v-for="(datakonten, urutkonten) in datakonten" :key="urutkonten">
                                <tbody>
                                    <tr>
                                        <td>
                                            {{ urutkonten + 1 }}
                                        </td>
                                        <td>
                                            {{ datakonten.NmSatker }}
                                        </td>
                                        <td class="text-right" v-if="showColumnOWPPMIS">
                                            {{ G_numFormat(datakonten.OWP) }}
                                        </td>
                                        <td class="text-right" v-if="showColumnOWPMONEV">
                                            {{ G_numFormat(datakonten.OWPMONEV) }}
                                        </td>
                                        <td v-if="showColumnAWPPMIS" class="text-right" v-for="(datadetail, urutdetail) in datakonten.Detail"
                                            :key="urutdetail">
                                            {{ G_numFormat(datadetail.awp) }}
                                        </td>
                                        <td v-if="showColumnAWPMONEV" class="text-right" v-for="(datadetail, urutdetail) in datakonten.Detail"
                                            :key="urutdetail">
                                            {{ G_numFormat(datadetail.awpmonev) }}
                                        </td>
                                        <td v-if="showColumnDIPAPMIS" class="text-right" v-for="(datadetail, urutdetail) in datakonten.Detail"
                                            :key="urutdetail">
                                            {{ G_numFormat(datadetail.dipa) }}
                                        </td>
                                        <td v-if="showColumnDIPAMONEV" class="text-right" v-for="(datadetail, urutdetail) in datakonten.Detail"
                                            :key="urutdetail">
                                            {{ G_numFormat(datadetail.dipamonev) }}
                                        </td>
                                        <td v-if="showColumnSPMPMIS" class="text-right" v-for="(datadetail, urutdetail) in datakonten.Detail"
                                            :key="urutdetail">
                                            {{ G_numFormat(datadetail.spm) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <tbody v-if="(datapesan == 'data kosong')">
                                <label>Data masih kosong</label>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datakonten: [],
            datatahun: [],
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            project_id: process.env.VUE_APP_PROJECT_ID,
            showColumnOWPPMIS: true,
            showColumnOWPMONEV: false,
            showColumnAWPPMIS: true,
            showColumnAWPMONEV: false,
            showColumnDIPAPMIS: true,
            showColumnDIPAMONEV: false,
            showColumnSPMPMIS: true,
        };
    },
    methods: {
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-Finance?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster = [];
                    this.datakonten = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = Response.data.content.data;
                        this.tanggalsinkron = this.datamaster[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.datamaster[0].TanggalDataMonev;
                        this.datakonten = this.datamaster[0].Content;
                        this.datatahun = this.datamaster[0].TahunData;
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.tanggalsinkron = new Date();
                        this.tanggaldatamonev = new Date();
                        this.datakonten = [];
                        this.datatahun = [];
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datamaster = [];
                this.tanggalsinkron = new Date();
                this.tanggaldatamonev = new Date();
                this.datakonten = [];
                this.datatahun = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>